import { useEffect } from 'react';
import useLocalStorage from './useLocalStorage';

export type ColorMode = 'light' | 'dark';
const KEY = 'color-theme';

/** Stored choice wins; otherwise follow the OS. */
export function initialColorMode(): ColorMode {
  try {
    const stored = window.localStorage.getItem(KEY);
    if (stored) return JSON.parse(stored) === 'dark' ? 'dark' : 'light';
  } catch { /* unreadable storage: fall back to the OS */ }
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark' : 'light';
}

const useColorMode = (): [ColorMode, (m: ColorMode) => void] => {
  const [colorMode, setColorMode] = useLocalStorage<ColorMode>(KEY, initialColorMode());
  useEffect(() => {
    document.body.classList.toggle('dark', colorMode === 'dark');
    document.documentElement.style.colorScheme = colorMode;
  }, [colorMode]);
  return [colorMode, setColorMode];
};

export default useColorMode;
